export default class Navigation {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Navigation;
		self.attachEvents();
	}


	attachEvents() {
		const self = this;

		$(document).on('pageLoad', function() {
			self.linkTopFrameiOS();
		});

		$(document).on('mouseover', '.js-on-hover-open-nav-sub', function() {
			let $nav = $(this).find('.header-nav-sub');
			self.openNav($nav);
		});

		$(document).on('mouseleave', '.js-on-hover-open-nav-sub', function() {
			let $nav = $(this).find('.header-nav-sub');
			self.closeNav($nav);
		});

		$(document).on('click', '.js-open-popup-sub-nav', function(e){
			e.preventDefault();
			var $this = $(this),
				$subMenu = $this.next('.popup-nav-sub');

			self.openPopupSubMenu($subMenu);
		});

		$(document).on('click', '.js-close-sub-menu', function(e){
			e.preventDefault();
			var $this = $(this),
				$subMenu = $this.closest('.popup-nav-sub');

			self.closePopupSubMenu($subMenu);
		});

		$(document).on('click', '.popup-nav-sub .mfp-close', function(e){
			e.preventDefault();
			var $this = $(this),
				$subMenu = $this.parents('.popup-nav-sub');

			self.closePopupSubMenu($subMenu);
		});


		$(document).on('click', '.product-nav', function(){
				$('.product-nav	').removeClass('is-active');
				$(this).addClass('is-active');
				$('.product-information').hide();
				let className = $(this).attr('class').split(' ')[1];
				$('.' + className.replace('product-nav', 'product-information')).show();
		});

	}

	openNav($nav) {
		const self = this;

		$nav.fadeIn(100);
	}

	closeNav($nav) {
		const self = this;

		setTimeout(function() {
			$nav.fadeOut(100);
		}, 100);
	}

	closePopupSubMenu($subMenu) {
		$subMenu.animate({
			'left': '100%',
			'right': '-100%'
		}, 400, function() {
			$subMenu.hide();
		});

		$subMenu.parents('.popup').removeClass('mod-disable-scrolling');
	}

	openPopupSubMenu($subMenu) {
		let $popup = $subMenu.parents('.popup');

		$subMenu.show();

		$subMenu.animate({
			'left': '0%',
			'right': '0%'
		});

		$popup.scrollTop(0);

		$popup.addClass('mod-disable-scrolling');
	}


	linkTopFrameiOS() {

		var ua = window.navigator.userAgent;
		var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
		var webkit = !!ua.match(/WebKit/i);
		var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);

		if(iOSSafari) {
			if (window.location !== window.parent.location) {
				var anchorElements = document.getElementsByTagName("a");

				for (var i = 0; i < anchorElements.length; i ++)
				{
					anchorElements[i].setAttribute("target", "_top");
				}
			}
		}

	}

}
